import React from "react";
import { ArrowLeft } from "lucide-react";

const EditSkelton = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header Skeleton */}
      <header className="bg-_white border-b">
        <div className="max-w-7xl mx-auto px-4 py-4 sm:py-6 sm:px-6 lg:px-8 flex flex-col sm:flex-row sm:justify-between sm:items-center">
          <div className="flex items-center mb-4 sm:mb-0">
            <div className="mr-4 p-2 rounded-full bg-gray-100">
              <ArrowLeft className="h-5 w-5 text-gray-400" />
            </div>
            <div className="h-8 bg-gray-200 rounded animate-pulse w-48 sm:w-64"></div>
          </div>
          <div className="h-8 bg-gray-200 rounded animate-pulse w-24"></div>
        </div>
      </header>

      {/* Main Content Skeleton */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-8">
        <div className="space-y-6">
          {/* Product Images Skeleton */}
          <div className="bg-_white shadow-sm rounded-lg overflow-hidden border border-_gray_lite">
            <div className="px-4 sm:px-6 py-4 border-b border-_gray_lite flex flex-col sm:flex-row sm:justify-between sm:items-center">
              <div className="h-6 bg-gray-200 rounded animate-pulse w-32 mb-2 sm:mb-0"></div>
              <div className="h-8 bg-gray-200 rounded animate-pulse w-24"></div>
            </div>
            <div className="p-4 sm:p-6">
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 sm:gap-4">
                {Array(5).fill(0).map((_, index) => (
                  <div key={index} className="aspect-w-1 aspect-h-1 w-full">
                    <div className="h-full bg-gray-200 rounded animate-pulse"></div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Product Details Skeleton */}
          <div className="bg-_white shadow-sm rounded-lg overflow-hidden border border-_gray_lite">
            <div className="px-4 sm:px-6 py-4 border-b border-_gray_lite flex justify-between items-center">
              <div className="h-6 bg-gray-200 rounded animate-pulse w-32"></div>
              <div className="h-5 bg-gray-200 rounded-full animate-pulse w-16"></div>
            </div>
            <div className="px-4 sm:px-6 py-4 space-y-4 sm:space-y-6">
              {/* Title input skeleton */}
              <div>
                <div className="h-4 bg-gray-200 rounded animate-pulse w-24 mb-2"></div>
                <div className="h-10 bg-gray-200 rounded animate-pulse w-full"></div>
              </div>

              {/* Price inputs skeleton */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
                <div>
                  <div className="h-4 bg-gray-200 rounded animate-pulse w-16 mb-2"></div>
                  <div className="h-10 bg-gray-200 rounded animate-pulse w-full"></div>
                </div>
                <div>
                  <div className="h-4 bg-gray-200 rounded animate-pulse w-32 mb-2"></div>
                  <div className="h-10 bg-gray-200 rounded animate-pulse w-full"></div>
                </div>
              </div>

              {/* Category select skeleton */}
              <div>
                <div className="h-4 bg-gray-200 rounded animate-pulse w-20 mb-2"></div>
                <div className="h-10 bg-gray-200 rounded animate-pulse w-full"></div>
              </div>

              {/* Description editor skeleton */}
              <div>
                <div className="h-4 bg-gray-200 rounded animate-pulse w-32 mb-2"></div>
                <div className="h-32 bg-gray-200 rounded animate-pulse w-full"></div>
              </div>
            </div>

            <div className="px-4 sm:px-6 py-4 bg-_gray_hover text-right">
              <div className="h-10 bg-gray-300 rounded animate-pulse w-32 inline-block"></div>
            </div>
          </div>

          {/* Sub Products Skeleton */}
          <div className="bg-_white shadow-sm rounded-lg overflow-hidden border border-_gray_lite">
            <div className="px-4 sm:px-6 py-4 border-b border-_gray_lite">
              <div className="h-6 bg-gray-200 rounded animate-pulse w-48"></div>
            </div>

            {/* Add Sub Product Form Skeleton */}
            <div className="px-4 sm:px-6 py-4 bg-_gray_hover border-b border-_gray_lite">
              <div className="space-y-4">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <div className="h-4 bg-gray-200 rounded animate-pulse w-24 mb-2"></div>
                    <div className="h-10 bg-gray-200 rounded animate-pulse w-full"></div>
                  </div>
                  <div>
                    <div className="h-4 bg-gray-200 rounded animate-pulse w-24 mb-2"></div>
                    <div className="h-10 bg-gray-200 rounded animate-pulse w-full"></div>
                  </div>
                </div>
                <div className="flex flex-col sm:flex-row sm:justify-end gap-2">
                  <div className="h-8 bg-gray-200 rounded animate-pulse w-20"></div>
                  <div className="h-8 bg-gray-300 rounded animate-pulse w-28"></div>
                </div>
              </div>
            </div>

            {/* Sub Products Table Skeleton */}
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-_gray_lite">
                <thead className="bg-_gray_hover">
                  <tr>
                    {['Title', 'Price', 'Status', 'Created At', ''].map((_, index) => (
                      <th key={index} className="px-4 sm:px-6 py-3 text-left">
                        <div className="h-4 bg-gray-200 rounded animate-pulse w-16"></div>
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody className="bg-_white divide-y divide-_gray_lite">
                  {Array(3).fill(0).map((_, rowIndex) => (
                    <tr key={rowIndex}>
                      <td className="px-4 sm:px-6 py-4">
                        <div className="h-4 bg-gray-200 rounded animate-pulse w-24"></div>
                      </td>
                      <td className="px-4 sm:px-6 py-4">
                        <div className="h-4 bg-gray-200 rounded animate-pulse w-16"></div>
                      </td>
                      <td className="px-4 sm:px-6 py-4 hidden sm:table-cell">
                        <div className="h-5 bg-gray-200 rounded-full animate-pulse w-16"></div>
                      </td>
                      <td className="px-4 sm:px-6 py-4 hidden md:table-cell">
                        <div className="h-4 bg-gray-200 rounded animate-pulse w-20"></div>
                      </td>
                      <td className="px-4 sm:px-6 py-4 text-right">
                        <div className="h-4 bg-gray-200 rounded animate-pulse w-12 ml-auto"></div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default EditSkelton;